import React, { useState, useEffect } from "react";
import { Modal } from "react-bootstrap";
import styles from "./AskTheTeamStyles.module.css";
import "../AdvanceFilters/AFModalsStyles.css";
import { useDispatch, useSelector } from "react-redux";
import { detectDomain, fetchUsers, submitQuestion } from "../../../API/api";
import { bindActionCreators } from "redux";
import { Actions } from "../../../Action";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
// import Button from '@mui/material/Button';
import { styled } from "@mui/material/styles";
import { Upload, message, Row, Col } from "antd";
import { Home_PAGE_URL } from "../../../Router/routerUrl";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { UploadOutlined } from "@ant-design/icons";
import Button from "../../../NewComponent/Button/Button";
import Button2 from "../../../NewComponent/Button2/Button2";
import { ReactComponent as FireIcon } from "../../../Icons/fire.svg";
import MultiSelect from "../../MultiSelect/MultiSelect";






const submitSuccessToast = () => {
  return (
    <>
      {/* <div style={{height:'100%'}}>
        <span style={{fontSize: "12px", fontWeight: "bold" }}>Thank you! Your question is in good hands</span>
        <br />
        <span style={{ fontSize: "10px" }}>
        You will be notified when answer is ready. Feel free to ask a new
        question
      </span>
      </div> */}
      <div style={{ display: 'flex', alignItems: 'start' }}>
        {/* <RadioButtonUncheckedIcon /> */}
        <CheckCircleIcon style={{ color: '07bc0c', padding: '3px', fontSize: '32px' }} />
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <span style={{ fontSize: "12px", fontWeight: "bold" }}>Thank you! Your question is in good hands</span>
          <span style={{ fontSize: "10px" }}>
            You will be notified when the answer is ready. Feel free to ask a new question.
          </span>
        </div>
      </div>

    </>
  );
};
const VisuallyHiddenInput = styled("input")({
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: 1,
  overflow: "hidden",
  position: "absolute",
  bottom: 0,
  left: 0,
  whiteSpace: "nowrap",
  width: 1,
  // color:'red'
});
const CustomUpload = styled(Upload)`
  .ant-upload.ant-upload-select {
    width:100%
  },
`;
export function AskTheTeamModal() {
  const navigate = useNavigate();
  const userState = useSelector((state) => state.user);
  const searchState = useSelector((state) => state.search);
  const modalState = useSelector((state) => state.domain);
  const [defaultDomain, setDefaultDomain] = useState("");
  const [additionText, setAdditionalText] = useState("");
  const [isUrgent, setIsUrgent] = useState(false);
  const [fetchUser, setFetchUser] = useState([]);
  const [inputval, setInputVal] = useState("");
  const [selected, setSelected] = useState([]);
  const [selectedFile, setSelectedFile] = useState([]);
  const dispatch = useDispatch();
  const { advanceFilterModalToggle, showNoShowConfetti, } = bindActionCreators(
    Actions,
    dispatch
  );

  const getQuestionDomain = () => {
    let payload = {
      question: searchState.inputValue,
    };
    detectDomain(payload)
      .then((res) => {
        if (res === undefined) return;
        setDefaultDomain(res.data.data);
      })
      .catch((err) => { });
  };

  const onChangeDomain = (e) => {
    setDefaultDomain(e.name);
  };

  const onChangeAdditionalText = (e) => {
    setAdditionalText(e.target.value);
  };

  const onChangeIsUrgent = (e) => {
    setIsUrgent(e.target.checked);
  };

  const getUsers = (e) => {
    setInputVal(e.target.value);
    if (e.target.value.length > 3) {
      fetchUsers(e.target.value, true)
        .then((res) => {
          if (res === undefined) return;
          let filtered = res.data.data.users.filter(function (obj) {
            let found = false;
            selected.filter((obj2) => {
              if (obj2.userUuid === obj.userUuid) {
                found = true;
              }
            });
            if (found === false) {
              return obj;
            }
          });
          setFetchUser(filtered);
        })
        .catch((err) => { });
    }
  };

  const onClickUsers = (val) => {
    setSelected([...selected, val]);
    setFetchUser([]);
    setInputVal("");
  };

  const onClickRemoveUsers = (val) => {
    let filteredData = selected.filter((obj) => {
      if (obj.userUuid !== val) {
        return obj;
      }
    });
    setSelected(filteredData);
  };

  const updateFireCount = (flag) => {
    if (flag) {
      userState.fastTrackInfo.used = userState.fastTrackInfo.used + 1;
    }
  };

  const getBase64 = (file, cb) => {
    if (file) {
      let reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = function () {
        cb(reader.result)
      };
      reader.onerror = function (error) {
      };
    }
  }

  const handleRemove = (file) => {
    setSelectedFile((prevFiles) =>
      prevFiles.filter((item) => item.name !== file.name)
    );

    return true;
  };

  const attachmentsData = (file) => {
    if(file === undefined) return null;
    if (file.file.status === 'removed') {
      return;
    }
    if (file.file.originFileObj && file.file.originFileObj instanceof Blob) {
      getBase64(file.file.originFileObj, (result) => {
        var size =
          file.file.size / (1024 * 1024) > 1
            ? file.file.size / (1024 * 1024) + " mB"
            : file.file.size / 1024 + " kB";
        let data = {
          caption: "",
          name: file.file.name,
          size: size,
          type: file.file.type,
          src: result,
          show: 1,
          isThumbNail: false,
        };
        // console.log(data, 'check data')
        // setSelectedFile([...selectedFile, data]);
        setSelectedFile((prevFiles) => [...prevFiles, data]);
      })
    }
  }

  const sendQuesToExpert = () => {
 
    if (selectedFile.length === 0) {
      let payload = {
        question: searchState.inputValue,
        domain: defaultDomain,
        type: "Vizerto",
        topicUuid: searchState.topicUuid,
        express: isUrgent,
        additionalContext: additionText,
        emailUuid: null,
        watchlist:
          selected.length > 0 ? selected.map((user) => user.userUuid) : selected,
      };
     
      submitQuestion(payload)
        .then((res) => {
          if (res === undefined) return;
          showNoShowConfetti(true);
        setTimeout(() => {
          showNoShowConfetti(false);
        }, 3000);
        updateFireCount(isUrgent);
        toast.success(submitSuccessToast(), {
            position: toast.POSITION.TOP_RIGHT,
            icon: false
          });
          navigate(`${Home_PAGE_URL}`);
        })
        .catch((err) => {
          return err;
        });
    }
    if (selectedFile.length > 0) {
      const formData = new FormData();
      let metadata = {
        question: searchState.inputValue,
        domain: defaultDomain,
        type: "Vizerto",
        topicUuid: searchState.topicUuid,
        express: isUrgent,
        additionalContext: additionText,
        emailUuid: null,
        watchlist:
          selected.length > 0 ? selected.map((user) => user.userUuid) : selected,
        uplodedFiles: selectedFile
      }
      // formData.append("metadata", JSON.stringify(metadata));
      // selectedFile.forEach((file, index) => {
      //   formData.append(`file`, file.originFileObj); // Appending actual file object as binary
      // });
      updateFireCount(isUrgent);
      submitQuestion(metadata)
        .then((res) => {
          if (res === undefined) return;
          toast.success(submitSuccessToast(), {
            position: toast.POSITION.TOP_RIGHT,
            icon: false
          });
          navigate(`${Home_PAGE_URL}`);
        })
        .catch((err) => {
          return err;
        });
    }
  };
  const onChangeFile = (info) => {
    // console.log(info, 'check info')
    // console.log(e.target.files,'cehck check check')
    // setSelectedFile([]);
    // setSelectedFile([e.target.files[0]]);
    let fileList = [...info.fileList];

    // Only keep the last uploaded file, you can remove this part if you want multiple uploads
    // fileList = fileList.slice(-1);

    // Update file list
    setSelectedFile(fileList);
  };
  const allowedFileTypes = [
    ".doc", ".DOC",
    ".docx", ".DOCX",
    ".xlsx", ".XLSX",
    ".xls", ".XLS",
    ".ppt", ".PPT",
    ".pptx", ".PPTX",
    ".csv", ".CSV",
    ".jpg", ".JPG",
    ".jpeg", ".JPEG",
    ".png", ".PNG",
    ".gif", ".GIF",
    ".pdf", ".PDF"
  ];

  const beforeUpload = (file) => {
    // const isAllowedType = allowedFileTypes.includes(
    //   `.${file.name.split(".").pop()}`
    // );
    // if (!isAllowedType) {
    //   message.error(`${file.name} is not a supported file type`);
    // }
    // return isAllowedType; // return true if valid file type, else false
    // Check file type
    const isAllowedType = allowedFileTypes.includes(`.${file.name.split(".").pop()}`);
    if (!isAllowedType) {
      toast.error(errorMessage(`${file.name} is not a supported file type`), {
        position: toast.POSITION.TOP_RIGHT,
      });
      return Upload.LIST_IGNORE; // Ignore this file
    }

    // Check file size
    const isValidSize = file.size / (1024 * 1024) <= 100; // 100 MB
    if (!isValidSize) {
      //  message.error('File size exceeds 100 MB.');
      toast.error( errorMessage(`File size exceeds 100 MB.`), {
        position: toast.POSITION.TOP_RIGHT,
      });
      return Upload.LIST_IGNORE; // Ignore this file
    }
    const isDuplicate = selectedFile.some(item => item.name === file.name);
    if (isDuplicate) {
      //  message.error('This file has already been uploaded.');
      toast.error(errorMessage(`This file has already been uploaded.`), {
        position: toast.POSITION.TOP_RIGHT,
      });
      return Upload.LIST_IGNORE; // Ignore this file
    }
    return true;
  };
  const customRequest = ({ file, onSuccess }) => {
    setTimeout(() => {
      // Simulate a successful upload without making any request
      onSuccess("ok");
    }, 1000);
  };

  const errorMessage = (message) => {
    return(
      <span style={{fontSize:'12px'}}>{message}</span>
    )
  }

  const buttonOnClickFunc = () => {

  }

  useEffect(() => {
    getQuestionDomain();
  }, []);
  return (
    <>
      <Modal
        show={modalState.modalState}
        onHide={() => advanceFilterModalToggle({ bool: false, value: "" })}
        centered={true}
        size={"lg"}
        style={{zIndex:'10000'}}
      >
        <Modal.Header
          // className={`${styles.modalHeaderBackground}`}
          closeButton
          // closeVariant="white" 
        >
          <Modal.Title className={styles.modalTitle}>
            <i className="fa fa-users"></i>&nbsp;&nbsp;&nbsp;Ask the Team
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="col-md-12 col-lg-12">
            <h2 className={styles.questionTextInAsk}>
              {searchState.inputValue}
            </h2>
            <br />
            <div style={{ display: "flex" }}>
              <span className={styles.domainText}>Domain:</span><span className={styles.domainSelect}>
                {/* <select
                  value={defaultDomain}
                  className="select-control"
                  style={{
                    height: "25px",
                    fontSize: "14px",
                    borderColor: "lightGray",
                    borderRadius: "5px",
                    color: "grey",
                    outline:"none"
                  }}
                  onChange={(e) => onChangeDomain(e)}
                >
                  {userState.visibleTopics.map((name) => {
                    return <option value={name}>{name}</option>;
                  })}
                </select> */}
                <MultiSelect isMulti={false} onChangeFunc={onChangeDomain} />
              </span>
            </div>
            <br />
            <p className={styles.domainText}>Additional Details:</p>
            <div className="mb-1">
              <textarea
                value={additionText}
                className="form-control"
                id="exampleFormControlTextarea1"
                rows="2"
                onChange={(e) => onChangeAdditionalText(e)}
              ></textarea>
            </div>
            {/* <br /> */}
                  {/*Code for upload attachment start */}
            <div className="mb-1 mt-1">
              <CustomUpload
                fileList={selectedFile}
                beforeUpload={beforeUpload}
                onChange={attachmentsData}
                showUploadList={true} // Show file list
                multiple={true}
                customRequest={customRequest}
                onRemove={handleRemove}
                className={styles.customUpload}
              >
                <div style={{display:"flex",justifyContent:'flex-end'}}>
                {/* <Button
                  icon={<UploadOutlined />}>Upload File</Button> */}
                  <Button2 onClickFunc={()=>buttonOnClickFunc()} children={<><UploadOutlined />&nbsp;Upload File</>} type="light" />
                  </div>
              </CustomUpload>
            </div>
            {/* Code for upload attachment end */}
            <p className={styles.domainText}>Watchlist:</p>
            <div className="mb-1">
              <div className="form-control">
                {selected.length > 0 && (
                  <div style={{ display: "flex", flexWrap: "wrap" }}>
                    {selected.map((obj) => {
                      return (
                        <p className={styles.selectedUserASG}>
                          {obj.firstName} {obj.lastName} {`<${obj.email}>`}{" "}
                          <span
                            className={styles.crossbuttonASK}
                            onClick={() => onClickRemoveUsers(obj.userUuid)}
                          >
                            x
                          </span>
                        </p>
                      );
                    })}
                  </div>
                )}
                <input
                  type="text"
                  className="form-control"
                  value={inputval}
                  placeholder="Enter name or email address"
                  style={{
                    border: "none ",
                    fontSize: "14px",
                    paddingLeft: "0px",
                    width: "100%",
                  }}
                  onChange={(e) => getUsers(e)}
                />
              </div>
              {fetchUser.length > 0 && (
                <div
                  className={styles.watchListUserslist}
                  style={{
                    width: "96%",
                    position: "absolute",
                    zIndex: "1000",
                    background: "#FFF",
                  }}
                >
                  {fetchUser.map((user) => {
                    return (
                      <div
                        style={{
                          padding: "7px",
                          border: "lightgrey solid 1px",
                          borderRadius: "5px",
                          fontSize: "12px",
                        }}
                      >
                        <span value={user} onClick={() => onClickUsers(user)}>
                          {user.firstName} {user.lastName} {`<${user.email}>`}
                        </span>
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
            <div
              className="form-check mt-4"
              style={{ display: "flex", justifyContent: "space-between" }}
            >
              <div>
                <input
                  className="form-check-input"
                  type="checkbox"
                  checked={isUrgent}
                  id="flexCheckDefault"
                  onChange={(e) => onChangeIsUrgent(e)}
                  disabled={userState.fastTrackInfo.total - userState.fastTrackInfo.used === 0 ? true : false}
                />
                <label className="form-check-label" for="flexCheckDefault" style={{fontFamily:'Inter',fontSize: '14px',
    color: 'rgb(42, 54, 74)',fontWeight:300}}>
                  <FireIcon style={{height:'20px'}} /> Urgent
                </label>
              </div>
              <div style={{display:'flex'}}>
                {/* <button
                  className={styles.cancelButtonASK}
                  onClick={() =>
                    advanceFilterModalToggle({ bool: false, value: "" })
                  }
                >
                  Cancel
                </button> */}
                <Button2 type="dark" children={'Cancel'} onClickFunc={()=>advanceFilterModalToggle({ bool: false, value: "" })} />
                &nbsp;&nbsp;
                {/* <button
                  className={`${styles.shareSubmitButtonASK} btn btn-primary`}
                  onClick={() => sendQuesToExpert()}
                >
                  Ask the Team
                </button> */}
                <Button type={'primary'} text='Ask the Team' onClickFunc={()=>sendQuesToExpert()} />
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}
